import React, { Component } from 'react';
import CreatableSelect from "react-select/creatable";

const options = [
  { value: 'test1', label: 'test 1' },
  { value: 'test2', label: 'test 2' },
  { value: 'test3', label: 'test 3' },
];

export default class CreatableMulti extends Component {
  state={
    edit:this.props.edit,
    tags:[],
    id:0


  }



  componentDidUpdate(prevProps, prevState) {
    if (this.state.id !==this.props.id&&this.props.id!==0) {
      this.setState({
        tags:this.props.tags,
        id:this.props.id,
      })
    }
  }




  handleEditMode=()=>{
    this.setState({
      edit:true
    })
  }

  handleDone=()=>{
    this.setState({
      edit:false
    },()=>{this.props.onOK(this.state.tags);})
  }

  handleChange = (newValue,actionMeta) => {
    if(newValue!==this.state.tags)
      {
        this.setState({
          tags:newValue
    })
      }
    console.group('Value Changed');
    console.log(newValue);
    console.log(`action: ${actionMeta.action}`);
    console.groupEnd();

  };
  render() {
    console.log(this.state.tags)
    console.log("this.props.tags")
    console.log(this.props.tags)
    return (<div>
                  {this.state.edit!==true ? <div>
                        <div style={{paddingRight:7}}>
                            <CreatableSelect
                            isDisabled
                            value={this.props.tags}
                            isMulti
                            options={options}
                          />
                        </div>
                        <div style={{paddingLeft:10}} className="profrm-row">
                          <span onClick={()=>this.handleEditMode()}></span>
                        </div>
                    </div>
                  :<div>
                        <div style={{paddingRight:7}}>
                            <CreatableSelect
                            isMulti
                            onChange={this.handleChange}
                            value={this.state.tags}
                            options={this.props.options}
                          />
                        </div>
                        <div style={{paddingLeft:10}} className="profrm-row active">
                          <span onClick={()=>this.handleDone()}></span>
                        </div>
                    </div>}
        </div>

    );
  }
}
